const translation = {
  EXPERIENCE_TITLE_H5: `Quelles compétences j'ai`,
  EXPERIENCE_TITLE_H2: 'Mon expérience',
  FRONT_END_TITLE: 'Développement frontal',
  BACK_END_TITLE: 'Développement back-end',
  EXPERIENCED: 'Expérimentée',
  ADVANCED: 'Avancée',
  BASIC: 'Basique',
  MID_LEVEL: 'intermédiaire',
};

export default translation;
